<template>
  <a-modal
    v-model:open="open"
    title="延期申请"
    :footer="null"
    :destroyOnClose="true"
    :keyboard="false"
    class="action-form-model-small"
  >
    <multiple_form :forms="forms" :edit="false" @submit="handelSubmit" />
  </a-modal>
</template>

<script setup>
  import {
    ref,
    defineProps,
    defineEmits,
    computed,
    watch,
    defineExpose,
  } from 'vue'
  import { message } from 'ant-design-vue'
  import multiple_form from '@/components/multiple_form'
  import { delay } from '@/api/car_application/enterprise_application'
  //初始化
  const props = defineProps({
    url: { default: 'carApplications' },
  })
  const id = ref()
  const open = ref(false)
  const emit = defineEmits()

  function openExtension(idValue) {
    id.value = idValue
    open.value = true
  }
  function closeExtension() {
    open.value = false
  }

  //编辑、新增的表单
  const forms = computed(() => [
    {
      id: 'car_list',
      itemWidth: '520px',
      formItem: [
        {
          type: 'dateRange',
          startField:
            props.url === 'carApplications'
              ? 'visitor_begin_time'
              : 'visit_begin_time',
          endField:
            props.url === 'carApplications'
              ? 'visitor_end_time'
              : 'visit_end_time',
          label: '延期时间',
          disabledDate(current, dayjs) {
            return current < dayjs().endOf('day')
          },
        },
        {
          type: 'input',
          field: 'reason',
          label: '延期原因',
        },
      ],
    },
  ])

  async function handelSubmit(data) {
    const res = await delay({ ...data, id: id.value }, props.url)
    if (res.success) {
      message.success('延期申请成功！')
      closeExtension()
      emit('success')
    } else {
      message.warn(res.message)
    }
  }

  defineExpose({
    openExtension,
  })
</script>

<style lang="less" scoped></style>
